export const CODE_CLOSE_WSS_LOGOUT = 4999;
export const REASON_CLOSE_WSS_LOGOUT = 'LOGOUT';
